export default __webpack_public_path__ + "9c21b810e75dfe7883080e056f1df043.woff";